var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AdminMachineList',{attrs:{"pk":'CML-',"lockedFilters":{ CustomerId: _vm.$route.params.customerId },"hideOwnershipFilters":"","allowSelectAll":"","groupByUnit":""}})}
var staticRenderFns = []

export { render, staticRenderFns }